import PrimaryPageContainer from "../components/containers/PrimaryPageContainer.jsx";
import ClaimContentSection from "../sections/claim/ClaimContentSection.jsx";
import ClaimStepProgress from "../sections/claim/ClaimStepProgress.jsx";

function ClaimPage() {
  return (
    <PrimaryPageContainer>
      <ClaimStepProgress />
      <ClaimContentSection />
    </PrimaryPageContainer>
  );
}

export default ClaimPage;
